import styled from 'styled-components'

type Props = {
	align: 'left' | 'right' | 'center'
	gridArea: string
}

export const AlignmentWrapper = styled.div<Props>`
	display: flex;
	align-items: center;
	justify-content: center;
	column-gap: 8px;
	grid-area: ${({ gridArea }) => gridArea};
	text-align: ${({ align }) => align};
`
